import Typography from "@mui/material/Typography";

/**
 * The one line under a field whose @mentions notify on save (task description, task comment), so
 * the writer knows typing "@" picks a teammate and when that person hears about it.
 */
export default function MentionSaveHint({
  action = "save"
}: {
  /** The verb on the button that sends: "save" for a task, "add" for a comment. */
  action?: string;
}) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      data-testid="mention-save-hint"
      sx={{ mt: 0.5 }}
    >
      Type @ to mention a teammate. They are notified when you {action}.
    </Typography>
  );
}
